import { ValidationErrorMessages } from '@constants/forms';
import { BooleanSelection } from '@src/types/index';
import { BroadbandFormValues } from '@src/types/yourDetails';

import type { BroadbandFormErrors } from '../types';

type ValidateOptions = {
  isBroadbandOnly?: boolean;
};
const validate = (
  values: BroadbandFormValues,
  { isBroadbandOnly = false }: ValidateOptions = {}
) => {
  const errors: BroadbandFormErrors = {};

  if (isBroadbandOnly) {
    if (!values.broadbandEmergMonitDevice) {
      errors.broadbandEmergMonitDevice = ValidationErrorMessages.FIELD_REQUIRED;
    }

    if (
      values.broadbandEmergMonitDevice === BooleanSelection.No &&
      !values.broadbandEmergAlt
    ) {
      errors.broadbandEmergAlt = ValidationErrorMessages.FIELD_REQUIRED;
    }
  }

  return errors;
};

export { validate };
